<div class="mb-3 {{hasError && submitted? 'is-invalid': ''}} dropdown-with-input full-width">
  <div class="label-container">
    <label>{{title | translate}}</label>
    <p *ngIf="mandatoryAsterix" class="colour-red margin-left-5">*</p>
  </div>
  <div ngbDropdown class="dropdown-without-label full-width" #dropdown="ngbDropdown">
    <button class="border-light-red btn btn-outline-gray dropdown-toggle-right full-width smaller-padding main-button" ngbDropdownToggle>
      <span class="dropdown-title-text">{{ selectedOption ? selectedOption : '' }}</span><span class="custom-toggle-arrow"></span>
    </button>
    <div ngbDropdownMenu class="dropdown-menu-custom full-width">
      <button class="dropdown-item full-width" style="justify-content: flex-end" *ngFor="let option of options" (click)="chooseOption(option)">
        {{ option }}
      </button>
      <div class="ps-1 pe-1 mb-1">
        <input type="text" class="form-control ps-5px"
               placeholder="{{placeholder | translate}}"
               [(ngModel)]="customInput"
               (keydown.enter)="handleEnter($event)"
        />
      </div>
    </div>
  </div>
</div>
